import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getWeedPDF = async ({ weedId, appInstanceId }: { weedId: number; appInstanceId: number }) => {
    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/weeds/pdf/${appInstanceId}/${weedId}/`,
        window.location.origin
    );
    window.open(apiUrl, '_blank');
};

export const getWeedControlPlansFromAPI = async ({ page, pageSize = 1000 }: { page: number; pageSize?: number }) => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('page_size', pageSize.toString());

    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/weeds/control-plans/?${params.toString()}`,
        window.location.origin
    );

    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};

export const getWeedsFromAPI = async ({
    countryCode,
    name,
    type,
    showInFinder,
}: {
    countryCode: string;
    name?: string;
    type?: string;
    showInFinder?: boolean;
}) => {
    const params = new URLSearchParams();
    params.append('country', countryCode);
    if (name) params.append('name', name);
    if (type) params.append('type', type);
    if (showInFinder !== undefined) params.append('show_in_finder', showInFinder.toString());

    const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/weeds/?${params.toString()}`, window.location.origin);

    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};
